import { useEffect, useMemo } from 'react';
import { Outlet, useMatches } from 'react-router-dom';
import { brandConfig } from '../../config/brands';
import { useTitleOverride } from '../../hooks/useDocumentTitle';
import { composeDocumentTitle, type RouteTitleHandle } from './documentTitle';

/**
 * document.title の解決を 1 箇所に集約するコンポーネント。
 *
 * 優先度: useDocumentTitle() の override > 最も深いマッチの handle > serviceName
 *
 * ルート定義 (routes.tsx) の handle に title / titleSuffix を書けば静的ページは
 * 完結する。商品名など実行時にしか分からないものは useDocumentTitle() を使う。
 */
export default function DocumentTitleSync() {
  const matches = useMatches();
  const override = useTitleOverride();

  // 浅い順にマッチするので、後勝ち = 最も深いルートの指定が採用される
  const fromHandles = useMemo(() => {
    let title: string | null = null;
    let suffix: string | null = null;
    for (const match of matches) {
      const handle = match.handle as RouteTitleHandle | undefined;
      if (handle?.title !== undefined) title = handle.title;
      if (handle?.titleSuffix !== undefined) suffix = handle.titleSuffix;
    }
    return { title, suffix };
  }, [matches]);

  useEffect(() => {
    const pageTitle = override ? override.title : fromHandles.title;
    const suffix = override?.suffix ?? fromHandles.suffix ?? brandConfig.serviceName;
    document.title = composeDocumentTitle(pageTitle, suffix);
  }, [override, fromHandles]);

  return <Outlet />;
}
